var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBentoWebtraderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.19199 15.2695L2.41797 14.4954L7.81539 9.09805L10.9821 12.2647L15.7433 7.54032H13.0013V6.45703H17.5846V11.0403H16.5013V8.31434L10.9821 13.8127L7.81539 10.6461L3.19199 15.2695Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBentoWebtraderIcon);
export default __webpack_public_path__ + "static/media/bento-webtrader-icon.352b8894fa03dcbb353ac881c2bb0b6a.svg";
export { ForwardRef as ReactComponent };